export default __webpack_public_path__ + "static/media/480_dummy-2014-store03-mobile-de.12c2d61e.png";